<template>
  <div class="office-page">
    <section v-if="office" class="office-profile">
      <div class="container">
        <div class="content">
          <div class="head">
            <Button
              v-if="highlighted"
              :to="{ path: '/', hash: 'available-offices' }"
              class="white left"
              arrow="left"
              >Főoldal</Button
            >
            <Button
              v-else
              :to="{ path: '/irodak' }"
              class="white left"
              arrow="left"
              >Irodák</Button
            >
          </div>
          <div class="title mb-3">
            <h2 class="h1">{{ office.name }}</h2>
          </div>
          <div v-if="!highlighted" class="office-info">
            <p class="office-info__address">
              {{ office.postalCode }} {{ office.city }},
              {{ office.addressLine }}
            </p>
            <div class="flex">
              <div class="office-info__left">
                <span class="office-info__offie-rating">
                  <img src="@/assets/offierating.png" class="object-contain" />
                  {{ office.offieRating || "-" }}
                </span>
              </div>
              <div class="office-info__right">
                <div class="office-info__data clear-both mb-4">
                  <img src="@/assets/office-details-price-icon.svg" />
                  <h4>Bérleti díj / m<sup>2</sup></h4>
                  <span>{{ priceTag(office) }}</span>
                </div>
                <div class="office-info__data clear-both mb-4">
                  <img src="@/assets/office-details-class-icon.svg" />
                  <h4>Kategória</h4>
                  <span>{{ office.class || "-" }}</span>
                </div>
                <div class="office-info__data clear-both mb-4">
                  <img src="@/assets/office-details-garage-icon.svg" />
                  <h4>Mélygarázs</h4>
                  <span>{{
                    office.undergroundGaragePrice
                      ? "Bérelhető"
                      : "Nem bérelhető"
                  }}</span>
                </div>
              </div>
            </div>
          </div>
          <div class="features mt-3">
            <Features v-if="highlighted" :data="office.features" />
            <Features v-else :data="office.offeredServices.data" />
          </div>
          <div class="text">
            <p>
              {{ office.description }}
            </p>
          </div>
          <div class="image">
            <ResponsiveImage
              v-if="highlighted"
              :data="{
                sizes: [640, 1280, 1920],
                width: image.width,
                height: image.height,
                src: image.src,
                alt: image.alt
              }"
            />
            <picture v-else class="flex responsive-image">
              <img
                :src="getImageUrl(image.url)"
                class="aspect-auto object-containt lg:w-[980px] w-auto"
              />
            </picture>
          </div>
          <div class="control">
            <Button
              v-if="highlighted"
              :to="{ path: '#kapcsolat' }"
              @click="next(this, event)"
              class="black"
              arrow="right"
              >Kapcsolat</Button
            >
            <Button v-else @click="offer" class="blue">
              {{
                !!cart.find(o => o.id === office.id) ? "Mégse -" : "Kosárba +"
              }}</Button
            >
          </div>
        </div>
      </div>
    </section>
    <section v-if="office && images" class="office-images diagonal-box">
      <div class="container">
        <nav>
          <Button
            :disabled="!hasPrev"
            arrow="left"
            class="gray circle"
            @click="prev"
          ></Button>
          <Button
            :disabled="!hasNext"
            arrow="right"
            class="gray circle"
            @click="next"
          ></Button>
        </nav>
      </div>
      <div class="cnt container">
        <vue-horizontal
          :button="false"
          ref="horizontal"
          @scroll-debounce="onScroll"
        >
          <div v-for="(img, i) in images" :key="i" class="gallery-item">
            <div class="gallery-item-container" @click="fullscreen">
              <ResponsiveImage
                v-if="highlighted"
                :data="{
                  sizes: [640, 1280],
                  width: 640,
                  height: 348,
                  src: img.src,
                  alt: img.alt
                }"
              />
              <picture
                v-else
                class="flex responsive-image"
                :data-src="getImageUrl(img.attributes.url)"
              >
                <img
                  :src="getImageUrl(img.attributes.url)"
                  class="aspect-auto object-cover"
                  style="width: 640px; height: 348px;"
                />
              </picture>
            </div>
          </div>
        </vue-horizontal>
      </div>
    </section>
    <div
      v-if="office"
      :class="{ fullscreen: true, opened: full }"
      ref="fullscreen"
      @click="exitfullscreen"
    >
      <ResponsiveImage
        v-if="fullsrc && highlighted"
        :data="{
          sizes: [640, 1280, 1920],
          width: 640,
          height: 348,
          src: fullsrc,
          alt: 'FWD'
        }"
      />
      <picture v-else-if="fullsrc" class="flex responsive-image">
        <div class="img-container">
          <div class="w-fit h-fit relative">
            <div class="absolute top-2 right-2">
              <Close />
            </div>
            <img
              :src="fullsrc"
              class="aspect-auto object-contain w-screen! h-screen!"
            />
          </div>
        </div>
      </picture>
    </div>
    <OfferModal
      v-if="office"
      ref="offerModal"
      :office="{ ...office, id: $route.params.id }"
    />
  </div>
</template>

<script>
import { mapState } from "vuex";
import Button from "@/components/inputs/Button.vue";
import ResponsiveImage from "@/components/ResponsiveImage.vue";
import Features from "@/components/Features.vue";
import OfferModal from "@/components/offices/OfferModal.vue";
import Close from "@/components/icons/Close.vue";

export default {
  name: "Office",
  components: {
    Button,
    Features,
    ResponsiveImage,
    OfferModal,
    Close
  },
  data() {
    return {
      office: null,
      highlighted: false,
      full: false,
      fullsrc: false,
      hasPrev: false,
      hasNext: true
    };
  },
  async created() {
    const id = this.$route.params.id.split("-")[1];
    if (parseInt(id, 10) > 0) {
      this.office = await this.$store.dispatch("offices/officeById", id);
    } else {
      this.highlighted = true;
      this.office = this.$store.getters.getBuildingBySlug(id);
    }
  },
  computed: {
    image() {
      if (!this.highlighted) {
        return this.office.mainImage.data.attributes;
      } else {
        return this.office.images.find(img => img.main === true);
      }
    },
    images() {
      if (!this.highlighted) {
        return this.office.gallery?.data;
      } else {
        return this.office.images.filter(img => img.main !== true);
      }
    },
    ...mapState({
      cart: state => state.offices.highlighted
    })
  },
  methods: {
    fullscreen(e) {
      document.body.style.overflow = "hidden";
      this.fullsrc = e.target.parentNode.getAttribute("data-src");
      this.full = true;
    },
    exitfullscreen() {
      document.body.style.overflow = "visible";
      this.full = false;
      this.fullsrc = false;
    },
    prev() {
      this.$refs.horizontal.prev();
    },
    next() {
      this.$refs.horizontal.next();
    },
    onScroll({ hasPrev, hasNext }) {
      this.hasPrev = hasPrev;
      this.hasNext = hasNext;
    },
    getImageUrl(imageUrl) {
      return `${process.env.VUE_APP_API_URL}${imageUrl}`;
    },
    priceTag(office) {
      if (office.priceFrom && office.priceTo) {
        return office.priceFrom == office.priceTo
          ? office.priceFrom
          : `${office.priceFrom} - ${office.priceTo}`;
      } else if (office.priceFrom) {
        return office.priceFrom;
      } else if (office.priceTo) {
        return office.priceTo;
      }

      return "-";
    },
    offer() {
      this.$store.commit("offices/toggleOffice", this.office);
      // this.$refs.offerModal.open();
    }
  }
};
</script>

<style lang="scss">
.office-page {
  background: $white;
  display: flex;
  flex-direction: column;
  min-height: 1000px;

  .fullscreen {
    position: fixed;
    left: 0;
    top: 0;
    z-index: -1;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    background: rgba(42, 46, 71, 0.9);
    opacity: 0;
    transition: all 0.3s ease-in-out;
    &.opened {
      z-index: 1000;
      opacity: 1;
    }
    picture {
      height: 100vh;
      width: 100vw;
      display: flex;
      align-items: center;
      justify-content: center;
      // padding: 20px;
      .img-container {
        @media screen and (min-width: $breakpoint) {
          padding-top: 60px;
        }
        padding-top: 0px;
        height: 85vh;
        width: 85vw;
        display: flex;
        align-items: center;
        justify-content: center;
        img {
          max-height: 85vh;
          max-width: 85vw;
          // max-width: 100%;
          // max-height: 100%;
          width: fit-content;
          height: fit-content;
          object-fit: contain;
        }
      }
    }
  }
}
.office-images {
  margin: 0;
  padding: 50px 0 66px !important;
  .h3 {
    margin: 0 16px 16px;
  }
  nav {
    display: none;
  }

  // &.diagonal-box:before {
  //   top: -30px;
  //   height: 31px;
  // }
  /* .VueCarousel {
    &-wrapper {
      max-width: 260px;
      overflow: visible;
      order: 2;
    }
    &-navigation {
      display: none;
    }
  } */
  .gallery-item {
    // flex: 0 0 75%;
    //margin-right: 8px;
    height: 420px;
    cursor: pointer;
    &-container {
      display: flex;
      justify-content: flex-start;
      flex-direction: column;
      border-radius: 16px;
      box-sizing: border-box;
      padding: 0;
      width: 100%;
      max-width: 250px;
      min-width: 200px;
      margin: 0 16px;
      overflow: hidden;
      .responsive-image {
        height: 100%;
        img {
          height: 100%;
          width: 100%;
          aspect-ratio: 35 / 46;
        }
      }
    }
  }

  @media screen and (min-width: $breakpoint) {
    margin: 0;
    padding: 50px 0 100px !important;
    .container {
      display: flex;
      align-items: flex-end;
      justify-content: space-between;
      margin: 0 auto 16px;
      .h3 {
        margin: 0 0 16px;
      }

      nav {
        display: flex;
        .button {
          margin: 0 0 0 16px;
        }
      }
    }
    /* .VueCarousel {
      &-wrapper {
        max-width: 350px;
        overflow: visible;
        order: 2;
      }
      &-navigation {

        width: 100%;
        max-width: 1110px;
        margin: auto;
        z-index: 100;
        height: 0;
        display: flex;
        justify-content: flex-end;
        align-items: flex-end;
        order: 1;
        button {
          position: relative;
          top: 0;
          display: block;
          width: 48px;
          height: 48px;
          background: $white;
          border-radius: 50%;
          padding: 0 !important;
          margin: 0 0 16px 16px !important;
          transform: none;
          outline: none;
          font-size: 0;
          user-select: none;
          background-image: url("~@/assets/arrow-left.svg");
          background-repeat: no-repeat;
          background-position: 50% 50%;
          // background-size: 100%;
        }
        &-next {
          transform: rotate(180deg) !important;
        }
        &-prev {
        }
      }
    } */
    .gallery-item {
      // margin-right: 30px;
      height: 460px;
      &-container {
        // margin: 0 15px;
        max-width: 350px;
      }
    }
  }
}
.office-profile {
  padding: 0 0 54px !important;
  background: $background;
  display: block;
  width: 100%;
  .container {
    .content {
      display: flex;
      flex-direction: column;
      .head {
        padding: 0 16px;
        margin-bottom: 24px;
        order: 1;
      }
      .title {
        order: 2;
        padding: 0 16px;
        margin-bottom: 10px;
        .h1 {
          font-size: 38px;
          line-height: 40px;
          font-weight: 500;
        }
      }
      .office-info {
        order: 3;
        margin-bottom: 20px;
        padding: 0 16px;
        // max-height: 220px;
        @media screen and (min-width: $breakpoint2) {
          width: 60%;
        }

        .office-info__address {
          font-weight: 400;
          font-size: 20px;
          line-height: 100%;
          color: #838383;
          margin: 0 0 24px 0;
          width: 60%;
        }

        .office-info__left {
          max-width: 154px;
        }

        .office-info__right {
          width: 100%;
        }

        .office-info__data {
          img {
            float: left;
            margin: 0 9px 0 0;
          }

          h4 {
            font-weight: 400;
            font-size: 14px;
            line-height: 13px;
            letter-spacing: 0.1em;
            text-transform: uppercase;
            margin: 0;
            padding-top: 2px;
          }

          span {
            display: block;
            font-weight: 400;
            font-size: 20px;
            line-height: 18px;
            color: #2b2f45;
            padding-top: 5px;
          }
        }

        .office-info__offie-rating {
          display: block;
          background: rgba(82, 82, 82, 0.5);
          border-radius: 10px;
          margin: 0 24px 0 0;
          padding: 16px;

          text-align: center;
          font-weight: 700;
          font-size: 58px;
          line-height: 53px;
          color: #ffffff;

          img {
            display: block;
            height: 54px;
            max-width: 100%;
            margin: 9px auto 0 auto;
          }
        }
      }
      .features {
        order: 4;
        margin-bottom: 24px;
        .feature-list {
          box-sizing: border-box;
          padding: 0 16px 16px;
        }
      }
      .text {
        padding: 0 16px;
        order: 6;
      }
      .image {
        @media screen and (min-width: $breakpoint) {
          position: absolute;
          right: 0;
        }
        order: 7;
        picture {
          display: block;
          width: 100%;
          height: auto;

          img {
            width: 100%;
            height: auto;
          }
        }
      }
      .control {
        margin: 0 16px 24px;
        order: 5;
        .button {
          width: 100%;
        }
      }
    }
  }
  @media screen and (min-width: $breakpoint) {
    margin: 0;
    padding: 90px 0 50px 0 !important;
    .container {
      position: relative;
      .content {
        position: relative;
        z-index: 10;
        display: flex;
        // height: 1000px;
        justify-content: flex-start;
        flex-wrap: wrap;
        flex-direction: column;
        .head {
          order: 1;
          padding: 0 100px 0 0;
          .button {
            display: inline-flex;
          }
        }
        .title {
          order: 2;
          width: 60%;
          box-sizing: border-box;
          padding: 0 100px 0 0;
          margin-bottom: 15px;
          .h1 {
            font-size: 54px;
            line-height: 60px;
            font-weight: 500;
          }
        }
        .office-info {
          order: 3;
          margin-bottom: 16px;
          padding: 0;
        }
        .features {
          order: 3;
          width: 60%;
          box-sizing: border-box;
          padding: 0 120px 0 0;
          margin-bottom: 24px;
          .feature-list {
            padding: 0;
          }
        }
        .text {
          order: 4;
          width: 60%;
          box-sizing: border-box;
          padding: 0 100px 0 0;
          margin-bottom: 24px;
          p {
            margin: 0 0 16px 0;
          }
        }
        .control {
          order: 5;
          width: 60%;
          box-sizing: border-box;
          padding: 0 100px 0 0;
          margin: 0;
          .button {
            width: auto;
          }
        }
        .image {
          order: 6;
          width: 45%;
          margin: 0 0 32px;
          .responsive-image {
            img {
              border-radius: 12px;
              height: 100%;
              max-height: 800px;
              width: auto;
              display: block;
            }
          }
        }
      }
    }
  }
}
</style>
